import {SELECT_TYPE} from './FileTypeResource';

export interface MainFilter {
    readonly name: string,
    readonly value: string
}

export const mainFileTypeResource: MainFilter[] = [
    {
        name: SELECT_TYPE, value: SELECT_TYPE
    },
    {
        name: 'archive', value: 'archive'
    },
    {
        name: 'audio', value: 'audio'
    },
    {
        name: 'document', value: 'document'
    },
    {
        name: 'image', value: 'image'
    },
    {
        name: 'other', value: 'other'
    },
    {
        name: 'presentation', value: 'presentation'
    },
    {
        name: 'sheet', value: 'sheet'
    },
    {
        name: 'video', value: 'video'
    }
];